import { useEffect } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { useAuthUser } from "@features/auth";

import {
  orderSetsKeyFactory,
  useDraftOrderSetsQuery,
} from "../queries/orderSetQueries";
import { findDraftOrderSet } from "./draftOrderSetIdentity";

/** Prefetch draft order-set detail caches for the current channel/territory. */
function useUserDraftOrderSets() {
  const queryClient = useQueryClient();
  const { channel, territory } = useAuthUser();
  const { data } = useDraftOrderSetsQuery();

  useEffect(() => {
    (["from-inventory", "on-demand"] as const).forEach((orderType) => {
      const orderSet = findDraftOrderSet(data, {
        orderType,
        channel,
        territory,
      });
      // Fetch rather than seed from the list row: rows carry no
      // orderSetVariants, and a detail that looks loaded but has an empty cart
      // lets "Add to cart" offer items that are already in it.
      if (orderSet) {
        queryClient.prefetchQuery(orderSetsKeyFactory.detail(orderSet.id));
      }
    });
    // `data` is referentially stable across refetches (structural sharing), so
    // this runs only when the draft list actually changes.
  }, [queryClient, channel, territory, data]);
}

const FetchUserDraftOrderSets = () => {
  useUserDraftOrderSets();

  return null;
};

export default FetchUserDraftOrderSets;
